import { render } from "./ItemDialogForIndexPage.vue?vue&type=template&id=73f1a306&scoped=true"
import script from "./ItemDialogForIndexPage.vue?vue&type=script&lang=js"
export * from "./ItemDialogForIndexPage.vue?vue&type=script&lang=js"

import "./ItemDialogForIndexPage.vue?vue&type=style&index=0&id=73f1a306&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-73f1a306"

export default script